export default __webpack_public_path__ + "static/media/mt.e91fb3cd.mp3";